import React from 'react';
import { Button, useTheme } from '@mui/material';

const PrimaryButton = ({ children, ...props }) => {
  const theme = useTheme();
  const accent = theme.palette.accent?.main || '#CB6423';

  return (
    <Button
      variant="outlined"
      {...props}
      sx={{
        my: 2,
        px: 2.5,

        height: 36,
        minHeight: 36,
        maxHeight: 36,
        lineHeight: 1,

        minWidth: 'unset',
        width: 'fit-content',

        textTransform: 'uppercase',
        fontWeight: 600,

        borderColor: accent,
        color: accent,

        transition: 'all 150ms ease',

        '&:hover': {
          borderColor: accent,
          color: accent,
          backgroundColor: `${accent}10`, // very subtle tint only
          boxShadow: 'none'
        }
      }}>
      {children}
    </Button>
  );
};

export default PrimaryButton;
